// extracted by css-extract-rspack-plugin
export default {"menu":"menu-s2T6li","menuList":"menuList-sjCEQ2","menuItem":"menuItem-T2KZFX"};